import { jsx, jsxs } from "react/jsx-runtime";
import EzHeading from "../EzHeading/EzHeading.es.js";
import EzLayout from "../EzLayout/EzLayout.es.js";
import stitches from "../theme.config.es.js";
import { clsx } from "../../utils/mergeProps.es.js";
const truncate = stitches.css({
  "& div": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "& *": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
});
const box = stitches.css({ position: "relative" });
const EzCardHeading = ({
  title,
  subtitle,
  actions,
  titleIcon,
  truncateHeading
}) => {
  const heading = title && /* @__PURE__ */ jsxs(EzLayout, { layout: "basic", alignY: "top", children: [
    titleIcon,
    /* @__PURE__ */ jsx(EzHeading, { size: "3", subheading: subtitle, truncateHeading, children: title })
  ] });
  const layout = actions && /* @__PURE__ */ jsxs(EzLayout, { layout: "cluster", css: { justifyContent: "space-between", alignItems: "baseline" }, children: [
    /* @__PURE__ */ jsx("div", { children: heading }),
    /* @__PURE__ */ jsx("div", { children: actions })
  ] });
  return /* @__PURE__ */ jsx("div", { className: clsx(box(), truncateHeading && truncate()), children: actions ? layout : heading });
};
EzCardHeading.displayName = "EzCardHeading";
export {
  EzCardHeading as default
};
//# sourceMappingURL=EzCardHeading.es.js.map
